export default "__VITE_ASSET__$n0UGFhm__"